export enum EProductSection {
  FLOW_MOBILE = "flow_mobile",
  FLOW_SUBSCRIPTION = "flow_subscription",
}
